import type { IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import EndpointDataFetcherFactory from "../widget-fetchers/EndpointDataFetcher";
import { TableSearchKeywordsDashboardWidgetFilters } from "./TableSearchKeywordsDashboardWidgetFilters";
import { TableWidget } from "./TableWidget";

export class DashboardTableWidget extends TableWidget {
    constructor() {
        super();
    }

    get templateUrl() {
        return "/app/components/widget/widget-templates/table.html";
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    static getWidgetDashboardType() {
        return "Table";
    }
    static getFiltersComponent() {
        return TableSearchKeywordsDashboardWidgetFilters;
    }

    protected getFetcherFactory(): IDataFetcherFactory<any> {
        return EndpointDataFetcherFactory;
    }
}

DashboardTableWidget.register();
